<template>
  <!--选择小区的弹窗-->
  <a-modal
    class="select-community-modal"
    title="搜索小区"
    :visible="visible"
    @cancel="cancel"
    :width="500"
    :maskClosable="true"
    v-bind="$store.state.modalConfig"
  >
    <a-select
      allowClear
      showSearch
      :filterOption="filterOption"
      dropdownClassName="community-dropdown"
      :default-active-first-option="false"
      @search="selectSearch($event)"
      @popupScroll="selectScroll($event)"
      v-model = 'selectValue'
      placeholder="请选择小区">
      <a-select-option @click="selectChange(el)" v-for="(el, index) of communityList" :key="index" :value="el.value">{{el.label}}
      </a-select-option>
    </a-select>

    <template slot="footer">
      <a-button key="submit" type="primary" @click="confirm">搜索</a-button>
    </template>
  </a-modal>
</template>

<script>
import { addEdit, inputSearch } from 'ant-design-vue-admin-x';
import empty from '@/utils/vueInstance';
import viewMixin from '@/utils/mixins/dataViews/dataVis_mixin';
export default {
  name: 'selectCommunity',
  mixins: [addEdit, inputSearch, viewMixin],
  data () {
    return {
      selectValue: undefined,
      isFetched: false,
      selectCurrentPage: 1,
      totalPage: 2,
      searchValue: undefined,

      visible: false,
      communityList: []
    };
  },
  created () {
    empty.$on('openModal', () => {
      this.openModal();
    });
  },
  methods: {
    /* 选择小区 */
    selectChange (item) {
      this.selectedItem = item;
    },
    /* 打开弹窗 */
    openModal () {
      this.visible = true;
      // this.$get({
      //   url: '/zw_statistics/get_user_communitys',
      //   params: { community_id: this.cId },
      //   config: { timeout: 20000 }
      // }).then(({data}) => {
      //   this.communityList = data;
      // });
      this.mycommunitySelectByStep(1, undefined);
    },
    mycommunitySelectByStep (pageNum, search) {
      let params = {
        search,
        pageNum,
        pageSize: 30
      };

      this._get({
        url: '/community/treeselect/page',
        params
      }).then(({data}) => {
        if (pageNum == undefined || pageNum == 1) {
          this.communityList = [].concat(data.rows);
          this.selectCurrentPage = 1;
        } else {
          this.communityList = this.communityList.concat(data.rows);
        }
        this.totalPage = data.totalPage;
        setTimeout(() => {
          this.isFetched = false;
        }, 150);
      });
    },
    // 当选择器为小区时 作分页展示
    selectScroll (e) {
      const { target } = e;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollTop + 2 + clientHeight >= scrollHeight) {
        if (this.isFetched) { return; }
        this.selectCurrentPage += 1;
        if (this.selectCurrentPage <= this.totalPage) {
          this.isFetched = true;
          this.mycommunitySelectByStep(this.selectCurrentPage, this.searchValue);
        }
      }
    },
    selectSearch (e) {
      this.searchValue = e; // 搜索值
      this.selectCurrentPage = 1;
      if (this.isFetched) { return; }
      this.isFetched = true;
      this.mycommunitySelectByStep(this.selectCurrentPage, this.searchValue);
    },
    /* 关闭对话框 */
    cancel () {
      this.selectedItem = undefined;
      this.selectValue = undefined;
      this.visible = false;
      this.searchValue = undefined;
    },
    confirm () {
      if (this.selectValue == undefined) {
        this.$message.error('请选择小区');
        return;
      }
      let id = this.selectedItem && this.selectedItem.value || undefined;
      if (!id) {
        this.$message.error('请选择小区');
        return;
      }
      if (this.selectedItem.value) {
        this.cId = this.selectedItem.value;
        this.communityName = this.selectedItem.label;
      }
      let hash = location.hash;
      if (hash.includes('?')) {
        hash = hash.split('?')[0];
      }

      const href = `${location.origin}${location.pathname}${hash}?id=${this.selectedItem.value}&name=${this.selectedItem.label}`;
      console.log('href: ', href);
      window.open(href);
      this.visible = false;
      this.selectedItem = undefined;
      this.selectValue = undefined;
      this.searchValue = undefined;
    }
  }
};
</script>

<style scoped>

</style>
